import { render, staticRenderFns } from "./TrainingQuizQuestionTypeGrading.vue?vue&type=template&id=3a262a27&"
import script from "./TrainingQuizQuestionTypeGrading.vue?vue&type=script&lang=js&"
export * from "./TrainingQuizQuestionTypeGrading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports